/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreatePlagiarismRunDataParser = 
/* #__PURE__ */ parsers.object([
    ['provider', codecString],
    ['oldAssignments', /* #__PURE__ */ codecArray(codecNumber), 'old_assignments'],
    [
        'providerOptions',
        /* #__PURE__ */ codec.record(codecString, codec.unknown),
        'provider_options',
    ],
]);
export class CreatePlagiarismRunData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreatePlagiarismRunDataParser.decode(input).map(res => new CreatePlagiarismRunData(res));
    }
    static unsafeDecode(input) {
        return CreatePlagiarismRunData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreatePlagiarismRunDataParser.encode(data);
    }
    static schema() {
        return CreatePlagiarismRunDataParser.schema();
    }
}
